/* The Mantel (Shopify port) · page behaviour for the Mantel sections. Loaded with defer; safe to include more than once.
   1. Live open/closed status. Paints every [data-open-status] with the same markup as shared/mantel-open-status.js:
        <span class="os-state">Open now </span><span class="os-sep">· </span><span class="os-time">until 9 PM</span>
      sets data-open="true|false" on it, and marks today's hours row ([data-hours-days="0,1,2,3,4"] gets .is-today).
      Hours come from data-mantel-hours on a .mantel root ("0,1,2,3,4|11:00|21:00;5,6|11:00|23:00", 0 = Sunday,
      America/Chicago time), written by the sections from their settings.
   2. Menu page: pins the jump chips once they reach the top (the chips sit in the header section, so CSS sticky
      can't outlive it), lights the chip for the section in view and keeps it visible in the rail.
   3. ?view= previews: on /pages/the-mantel?view=mantel (or ?view=the-mantel-menu) links between the two Mantel
      pages keep the preview view, so a staging walk-through stays on the new templates. Live pages are untouched. */
(function () {
  'use strict';
  if (window.MantelPage) { window.MantelPage.init(); return; }

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. open status ---------- */
  function toMin(t) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(t).trim());
    return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null;
  }
  function parseHours(str) {
    var map = {};
    String(str || '').split(';').forEach(function (row) {
      var p = row.split('|');
      if (p.length < 3) return;
      var open = toMin(p[1]), close = toMin(p[2]);
      if (open === null || close === null) return;
      if (close <= open) close += 1440;  // e.g. 11:00–01:00 closes 1 AM the next day
      p[0].split(',').forEach(function (d) {
        var n = parseInt(d, 10);
        if (n >= 0 && n <= 6) map[n] = [open, close];
      });
    });
    return map;
  }
  function hours() {
    var el = document.querySelector('.mantel[data-mantel-hours]');
    return parseHours(el && el.getAttribute('data-mantel-hours'));
  }
  function nowChicago() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      var h = parseInt(get('hour'), 10); if (h === 24) h = 0;
      return { day: DAYS.indexOf(get('weekday')), min: h * 60 + parseInt(get('minute'), 10) };
    } catch (e) {
      var d = new Date(); return { day: d.getDay(), min: d.getHours() * 60 + d.getMinutes() };
    }
  }
  function fmt(m) {
    var h = Math.floor(m / 60), mm = m % 60, ap = h >= 12 && h < 24 ? 'PM' : 'AM', hh = ((h + 11) % 12) + 1;
    return hh + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + ' ' + ap;
  }
  function status(H) {
    var n = nowChicago(), oc = H[n.day], y = H[(n.day + 6) % 7];
    if (y && y[1] > 1440 && n.min < y[1] - 1440) return { open: true, text: 'Open now · until ' + fmt(y[1] - 1440) };
    if (oc && n.min >= oc[0] && n.min < oc[1]) return { open: true, text: 'Open now · until ' + fmt(oc[1]) };
    if (oc && n.min < oc[0]) return { open: false, text: 'Opens today at ' + fmt(oc[0]) };
    for (var i = 1; i <= 7; i++) {
      var d = (n.day + i) % 7;
      if (H[d]) return { open: false, text: 'Closed now · opens ' + (i === 1 ? 'tomorrow' : DAYS[d]) + ' at ' + fmt(H[d][0]) };
    }
    return null;
  }
  function paintStatus() {
    var H = hours(), d = nowChicago().day;
    // no readable hours: keep the server-rendered fallback text rather than guess
    var s = Object.keys(H).length ? status(H) : null;
    if (s) {
      var els = document.querySelectorAll('[data-open-status]');
      for (var i = 0; i < els.length; i++) {
        var parts = s.text.split(' · ');
        // state and time as separate spans so narrow slots can stack them without a stranded separator
        els[i].innerHTML = parts.length === 2
          ? '<span class="os-state">' + parts[0] + ' </span><span class="os-sep">· </span><span class="os-time">' + parts[1] + '</span>'
          : s.text;
        els[i].setAttribute('data-open', s.open ? 'true' : 'false');
      }
    }
    var rows = document.querySelectorAll('[data-hours-days]');
    for (var j = 0; j < rows.length; j++) {
      var days = rows[j].getAttribute('data-hours-days').split(',').map(function (x) { return parseInt(x, 10); });
      rows[j].classList.toggle('is-today', days.indexOf(d) > -1);
    }
  }

  /* ---------- 2. menu chips: pin + scroll-spy ---------- */
  var chipsState = null;
  function stickyTop(el) {
    var v = parseFloat(getComputedStyle(el).getPropertyValue('--mantel-sticky-top'));
    return isNaN(v) ? 0 : v;
  }
  var stuckPx = 0;
  function stuckHeader() {
    var hdr = document.querySelector('.mcc-header, sticky-header, .shopify-section-header-sticky');
    if (!hdr || window.pageYOffset < hdr.offsetHeight) return 0;
    var r = hdr.getBoundingClientRect();
    return r.top <= 1 && r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  function syncStuckHeader() {
    var px = stuckHeader();
    if (px === stuckPx) return;
    stuckPx = px;
    var roots = document.querySelectorAll('.mantel');
    for (var i = 0; i < roots.length; i++) {
      if (px) roots[i].style.setProperty('--mantel-sticky-top', px + 'px'); else roots[i].style.removeProperty('--mantel-sticky-top');
    }
  }
  function teardownChips() {
    if (!chipsState) return;
    window.removeEventListener('scroll', chipsState.onScroll);
    window.removeEventListener('resize', chipsState.onScroll);
    if (chipsState.io) chipsState.io.disconnect();
    chipsState = null;
  }
  function initChips() {
    teardownChips();
    var nav = document.querySelector('.mantel [data-mantel-chips]');
    if (!nav) return;
    var slot = nav.parentNode;
    var track = nav.querySelector('.chips__track') || nav;
    var chips = [].slice.call(nav.querySelectorAll('a.chip[href^="#"]'));
    var ids = chips.map(function (c) { return decodeURIComponent(c.getAttribute('href').slice(1)); });
    var lit = nav.querySelector('.chip[aria-current="true"]');
    var current = lit ? ids[chips.indexOf(lit)] : null;  // the first chip is lit in the markup until a group arrives

    function light(id) {
      if (!id || id === current) return;
      current = id;
      chips.forEach(function (c, i) { if (ids[i] === id) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current'); });
      var c = chips[ids.indexOf(id)];
      if (!c) return;
      var left = Math.max(0, c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2);
      if (track.scrollTo) track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' }); else track.scrollLeft = left;
    }
    /* One pass per scroll event (browsers fire at most one per frame): read every position first, then write. */
    function update() {
      syncStuckHeader();
      var top = stickyTop(nav), h = nav.offsetHeight;
      var slotTop = slot.getBoundingClientRect().top;
      var roots = document.querySelectorAll('.mantel--menu');
      var bottom = roots.length ? roots[roots.length - 1].getBoundingClientRect().bottom : Infinity;
      var line = top + h + 20, found = null;
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el && el.getBoundingClientRect().top <= line) found = ids[i];  // the group whose top has passed under the chips
      }
      if (slotTop <= top && bottom > top) {
        // pinned; like sticky, once the menu's end reaches the bar it pushes the bar up with the content
        var push = Math.min(0, bottom - top - h);
        slot.style.height = h + 'px';
        nav.classList.add('is-pinned');
        nav.style.transform = push ? 'translateY(' + push + 'px)' : '';
      } else {
        nav.classList.remove('is-pinned');
        nav.style.transform = '';
        slot.style.height = '';
      }
      light(found || ids[0]);
    }

    chipsState = { onScroll: update, io: null };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    // IntersectionObserver: a group crossing the band under the chips (also covers jumps that skip scroll events)
    if (!('IntersectionObserver' in window)) return;
    var band = Math.round(stickyTop(nav) + nav.offsetHeight + 20);
    chipsState.io = new IntersectionObserver(update, { rootMargin: '-' + band + 'px 0px -55% 0px' });
    ids.forEach(function (id) { var el = document.getElementById(id); if (el) chipsState.io.observe(el); });
  }


  /* ---------- 3. ?view= previews ---------- */
  function previewLinks() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('view')) return;
    var root = document.querySelector('.mantel[data-main-path]');
    if (!root) return;
    var mainPath = root.getAttribute('data-main-path'), menuPath = root.getAttribute('data-menu-path');
    var mainView = root.getAttribute('data-main-view'), menuView = root.getAttribute('data-menu-view');
    if (!mainPath || !mainView || !menuView) return;
    var links = document.querySelectorAll('.mantel a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.hasAttribute('data-preview-done')) continue;
      var u;
      try { u = new URL(href, window.location.href); } catch (e) { continue; }
      if (u.origin !== window.location.origin) continue;
      var view = u.pathname === menuPath ? menuView : (u.pathname === mainPath ? mainView : null);
      if (!view) continue;
      var p = new URLSearchParams(window.location.search);
      p.set('view', view);
      a.setAttribute('href', mainPath + '?' + p.toString() + u.hash);
      a.setAttribute('data-preview-done', '');
    }
  }

  function init() {
    paintStatus();
    initChips();
    previewLinks();
  }
  function smoothLater() { window.setTimeout(function () { document.documentElement.classList.add('mantel-smooth'); }, 0); }
  if (document.readyState === 'complete') smoothLater(); else window.addEventListener('load', smoothLater);

  window.MantelPage = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(paintStatus, 60000);
  // theme editor: sections re-render in place
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { window.setTimeout(init, 0); });
})();
